<!-- Container-fluid starts-->
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card tab2-card">
                <div class="card-header">
                    <h5>Change Password</h5>
                </div>
                <div class="card-body tab2-card {{env.deviceType() ? 'pt-0' : ''}}">
                    <form [formGroup]="accountForm" class="needs-validation user-add" novalida>
                        <div class="form-group row">
                            <label for="validationCustom5" class="col-xl-3 col-md-4"><span>*</span>
                                Old Password</label>
                            <div class="col-xl-8 col-md-7">
                                <div class="input-group">
                                    <input class="form-control " formControlName="oldpassword" id="validationCustom5"
                                           type="password" placeholder="Old Password" maxlength="20" required=""
                                           [type]="conps ? 'password' : 'text'">
                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2"
                                                              style="cursor: pointer">
                                                            <i [class]="conps ? 'fa fa-eye-slash' : 'fa fa-eye'"
                                                               aria-hidden="true" (click)="conps = !conps"></i>
                                                        </span>
                                    </div>
                                </div>
                                <em class="error"
                                    *ngIf="accountForm.get('oldpassword').hasError('required') && (accountForm.get('oldpassword').dirty || accountForm.get('oldpassword').touched)">Old
                                    Password is required</em>
                                <em *ngIf="accountForm.get('oldpassword').hasError('minlength')" class="error">Minimum 5
                                    characters required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom0" class="col-xl-3 col-md-4"><span>*</span>
                                New Password</label>
                            <div class="col-xl-8 col-md-7">
                                <div class="input-group">
                                    <input class="form-control " formControlName="password" id="validationCustom0"
                                           type="password" placeholder="New Password" maxlength="20" required=""
                                           [type]="conps1 ? 'password' : 'text'">
                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon32"
                                                              style="cursor: pointer">
                                                            <i [class]="conps1 ? 'fa fa-eye-slash' : 'fa fa-eye'"
                                                               aria-hidden="true" (click)="conps1 = !conps1"></i>
                                                        </span>
                                    </div>
                                </div>
                                <em class="error"
                                    *ngIf="accountForm.get('password').hasError('required') && (accountForm.get('password').dirty || accountForm.get('password').touched)">Password
                                    is required</em>
                                <em *ngIf="accountForm.get('password').hasError('minlength')" class="error">Minimum 5
                                    characters required</em>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label for="validationCustom1" class="col-xl-3 col-md-4"><span>*</span>
                                Confirm Password</label>
                            <div class="col-xl-8 col-md-7">
                                <div class="input-group">
                                    <input class="form-control" formControlName="confirmPassword" id="validationCustom1"
                                           type="password" placeholder="Confirm Password" required=""
                                           [type]="conps2 ? 'password' : 'text'">
                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon31"
                                                              style="cursor: pointer">
                                                            <i [class]="conps2 ? 'fa fa-eye-slash' : 'fa fa-eye'"
                                                               aria-hidden="true" (click)="conps2 = !conps2"></i>
                                                        </span>
                                    </div>
                                </div>
                                <em class="error"
                                    *ngIf="!accountForm.get('confirmPassword').valid && (accountForm.get('confirmPassword').dirty || accountForm.get('confirmPassword').touched)">Confirm
                                    Password is required</em>
                                <div *ngIf="checkPasswords()">
                                    <em class="error help-block">
                                        Enter same password as above
                                    </em>
                                </div>
                            </div>
                        </div>
                    </form>
                    <div class="pull-right mt-2">
                        <button type="button" (click)="changePassword()" class="btn btn-primary">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Container-fluid Ends-->
